import "./PhoneLogin.css";
import Footer from "../Footer/Footer";
import NewHeader from "../NewHeader/NewHeader";
import SubFooter from "../SubFooter/SubFooter";
import ScrolltoTop from "../Scrolltotop/ScrolltoTop";
import React, { useState, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  EditForm,
  otpLogin,
  ExistingCustomerCheck,
  getCustomerDashboard,
  otpVerification,
  getCall,
  AddtoCart,
  setLogout,
} from "../../Redux/Actions";
import { GET_CUSTOMER_DASHBOARD_REQUEST } from "../../Redux/Constants";
import { useLocation, useParams } from "react-router";
import { useHistory } from "react-router-dom";
import OtpInput from "react-otp-input";
// import "./ModalForm.css";
import { Carousel } from "react-responsive-carousel";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import "react-responsive-modal/styles.css";
import loginmodelimage from "../../Assets/loginmodelimage.png";
import login1 from "../../Assets/login-image2.svg";
import login2 from "../../Assets/login-image1.svg";
import login3 from "../../Assets/login-image3.svg";
import { element } from "prop-types";
import { data } from "../../Pages/packageDetailsPage/Data/AccreditationsData";
import { Scroll } from "../Scroll function/scroll";
// import { useReadOTP } from "react-read-otp";

const LoginImages = [
  {
    id: 1,
    img: login1,
    title: "Digital Report Bank",
    desc: "Access speedy reports from everywhere and anywhere.",
  },
  {
    id: 2,
    img: login2,
    title: "Free Home Sample Pick-up",
    desc: "Care at your Convenience. Get tested from the comfort of your home.",
  },
  {
    id: 3,
    img: login3,
    title: "Free Call Consultationg",
    desc: "Have a doubt? Clear it out.",
  },
];

const responsive = {
  superLargeDesktop: {
    // the naming can be any, depends on you.
    breakpoint: { max: 4000, min: 3000 },
    items: 5,
  },
  desktop: {
    breakpoint: { max: 3000, min: 1024 },
    items: 1,
  },
  tablet: {
    breakpoint: { max: 1024, min: 464 },
    items: 1,
  },
  mobile: {
    breakpoint: { max: 464, min: 0 },
    items: 1,
  },
};

const PhoneLogin = (props) => {
  const dispatch = useDispatch();
  const [disable, setDisable] = useState(false);
  const [messageTel, setMessageTel] = useState("");
  const [minutes, setMinutes] = useState(0);
  const [seconds, setSeconds] = useState(0);
  console.log("????????????", props);

  const packSlug = props.state;
  const otpverification = useSelector((state) => state.otpverification);
  const { loading, otpVerificationResponse, error } = otpverification;

  // const { routefrom } = useParams()
  const { pushToUrl, packageId, packageSlug } = useLocation();
  const history = useHistory();

  const [pushTo, setpushTo] = useState("");


  useEffect(() => {
    setpushTo(pushToUrl);
  }, [pushToUrl]);

  //FUNCTIONS FROM OLD LOGN PAGE
  // const [open, setOpen] = useState(false);
  // const onOpenModal = () => setOpen(true);
  // const onCloseModal = () => setOpen(false);
  const [otpError, setOtpError] = useState("");
  const [userdetail, setuserdetail] = useState(false);
  const [phoneNumber, setPhoneNumber] = useState("");
  //for verify model
  const [otpverify, setOtpVerify] = useState("");
  const [loginForm, setLoginForm] = useState(true);
  const [otpForm, setOtpForm] = useState(false);
  const [otp, setOtp] = useState();
  const location = useLocation();
  const [UserName, setUserName] = useState("");
  const [Gender, setGender] = useState("");
  const [Email, setEmail] = useState("");
  const [age, setage] = useState("");
  const [nameError, setNameEror] = useState("");
  const [ageError, setAgeError] = useState("");
  const [emailError, setEmailError] = useState("");
  const [resend, setResend] = useState(false);

  // const [enabled, setEnabled] = useState(false);
  // const [otp2, setotp2] = useState("");
  // useReadOTP(setotp2, {
  //   enabled,
  // });

  // useEffect(() => {
  //   if (otp2 != "") {
  //     setotp1(otp2.toString().split(""));
  //   }
  // }, [otp2]);

  // setTimeout(()=>{useReadOTP(setotp2, {
  //   enabled,
  // });},30000);
  // useEffect(() => {
  //   if(otp!=""){

  //     setotp1(otp.split("").map(i=>Number(i)))
  //   }
  // }, [otp])
  // setTimeout(() => {
  //   setOtp("393939")
  //   console.log("ran",otp)
  // }, 20000);

  useEffect(() => {
    if ("OTPCredential" in window) {
      const ac = new AbortController();
      navigator.credentials
        .get({
          otp: { transport: ["sms"] },
          signal: ac.signal,
        })
        .then((otp) => {
          setOtp(otp.code);
          ac.abort();
        });
    }
  }, []);

  const handleName = (e) => {
    setUserName(e.target.value);

    const characterRegex = /^([A-Za-z]+[ ]?)+$/;
    setNameEror("");
    if (!e.target.value.match(characterRegex)) {
      setNameEror("invalid user name");
    }
    if (e.target.value == "") {
      setNameEror("");
      setDisable(false);
    }
  };
  const handleGender = (e) => {
    setGender(e.target.value);
  };
  const handleEmail = (e) => {
    setEmail(e.target.value);
    // const emailRegex = /^[a-zA-Z0-9+_.-]+@[a-zA-Z0-9.-]+$/;
    // setEmailError("");
    // if (!e.target.value.match(emailRegex)) {
    //   setEmailError("invalid user emai");
    // }
    // if (e.target.value == "") {
    //   setEmailError("");
    //   setDisable(false)
    // }
  };
  const handleAge = (e) => {
    setage(e.target.value);
    if (e.target.value > 110 || e.target.value < 0) {
      setAgeError("Enter valid age");
    } else {
      setAgeError("");
      setDisable(false);
    }
  };

  const handleUserDetailSubmit = (e) => {
    e.preventDefault();
    setDisable(false);
    // history.push("/userdashboard");
    // window.location.href = `${process.env.RAZZLE_APP_BASE_URL}/dashboard/`;
    const datakey = JSON.parse(localStorage.getItem("user"));

    const token = datakey.token;
    const phonenumber = datakey.username;

    const body = {
      fullname: UserName,
      age: parseInt(age),
      email: Email,
      gender: Gender,
    };

    dispatch(EditForm(token, body, phonenumber));
    setTimeout(() => {
      dispatch(getCustomerDashboard(token));
    }, 300);
    close();
  };
  const handleSubmit = (e) => {
    e.preventDefault();
    setotp1([...otp1.map((d) => "")]);
    const otpModel = { phone_number: phoneNumber };

    let phoneno = /^\d{10}$/;
    let newphone = /^\d{11}$/;
    //|| isNaN(phoneNumber)
    if (!phoneNumber.match(phoneno) || parseInt(phoneNumber[0]) < 6) {
      setMessageTel(`invalid phone number`);
      setDisable(true);
    } else {
      setMessageTel("");
      setDisable(false);
      setSeconds(30);
      dispatch(otpLogin(otpModel));
      // setEnabled(true);
      const body = {
        phone_no: phoneNumber,
        source: "Ecommerce",
        url: "https://redcliffelabs.com/login",
      };
      const GenrateLeadTenMins = setTimeout(() => {
        dispatch(getCall(body));
      }, 600000);

      setLoginForm(false);
      setOtpForm(true);
    }

    if (
      !phoneNumber.match(newphone) ||
      parseInt(phoneNumber[0]) === "+" ||
      parseInt(phoneNumber[0]) === "-"
    ) {
      setMessageTel(`Enter Phone Number Only`);
      setDisable(true);
    } else if (
      !phoneNumber.match(newphone) ||
      parseInt(phoneNumber[0]) !== 0 ||
      parseInt(phoneNumber[1]) < 6
    ) {
      setMessageTel(`Enter Phone Number Only`);
      setDisable(true);
    } else {
      setMessageTel("");
      setDisable(false);

      setSeconds(30);
      dispatch(otpLogin(otpModel));
      // setEnabled(true);

      setLoginForm(false);
      setOtpForm(true);
    }
  };

  const handleResend = (e) => {
    e.preventDefault();
    setotp1([...otp1.map((d) => "")]);
    const otpModel = { phone_number: phoneNumber };

    let phoneno = /^\d{10}$/;
    let newphone = /^\d{11}$/;
    //|| isNaN(phoneNumber)
    if (!phoneNumber.match(phoneno) || parseInt(phoneNumber[0]) < 6) {
      setMessageTel(`invalid phone number`);
      setDisable(true);
    } else {
      setMessageTel("");
      setDisable(false);
      setSeconds(30);
      dispatch(otpLogin(otpModel));
      // setEnabled(true);
      const body = {
        phone_no: phoneNumber,
        source: "Ecommerce",
        url: "https://redcliffelabs.com/login",
      };
      const GenrateLeadTenMins = setTimeout(() => {
        dispatch(getCall(body));
      }, 600000);

      setLoginForm(false);
      setOtpForm(true);
      setResend(!resend);
    }

    if (
      !phoneNumber.match(newphone) ||
      parseInt(phoneNumber[0]) === "+" ||
      parseInt(phoneNumber[0]) === "-"
    ) {
      setMessageTel(`Enter Phone Number Only`);
      setDisable(true);
    } else if (
      !phoneNumber.match(newphone) ||
      parseInt(phoneNumber[0]) !== 0 ||
      parseInt(phoneNumber[1]) < 6
    ) {
      setMessageTel(`Enter Phone Number Only`);
      setDisable(true);
    } else {
      setMessageTel("");
      setDisable(false);

      setSeconds(30);
      dispatch(otpLogin(otpModel));
      // setEnabled(true);

      setLoginForm(false);
      setOtpForm(true);
    }
  };

  const otpClear = () => {
    setOtp("");
  };
  const handleChange = (event) => {
    setPhoneNumber(event.target.value);
    //  const validate = "^(\+\d{1,2}\s)?\(?\d{3}\)?[\s.-]\d{3}[\s.-]\d{4}$";
    setMessageTel("");
    setDisable(false);
  };

  //ALL OTP VERIFY CODE STARTS HERE
  const otpResponse = useSelector((state) => state.otpLogin);
  const existingCustomer_data = useSelector(
    (state) => state.getCustomerDashboard
  );
  const { loading: loadingotp } = otpResponse;
  // console.log("getting otp Response data", otpResponse);

  const OtpLoginResponse = otpResponse.otploginResponse;

  //existing user change

  const selectedCity = useSelector((state) => state.cityOnTopNav);

  useEffect(() => {

    const AddToCartForPackID = (id, token) => {
      let body = {
        package: id,
      };
      return new Promise((resolve, reject) => {
        const success = (data) => {
          if (data) {
            return resolve(data)
          } else {
            return reject("Unable Add package")
          }
        }
        dispatch(AddtoCart(body, token, success))
      })
    }

    if (error) {
      setOtpError(error);
    } else if (otpVerificationResponse && otpVerificationResponse?.user) {
      localStorage.setItem("user", JSON.stringify(otpVerificationResponse?.user));
      if (pushToUrl && packageId && packageSlug) {
        console.log("<<< pushToUrl && packageId && packageSlug ")
      } else if (pushToUrl && packageId) {
        console.log("<<< pushToUrl && packageId")
        AddToCartForPackID(packageId, otpVerificationResponse?.user?.token).then((res) => {
          history.push(`/${pushToUrl}`)
        }).catch((error) => {
          console.log(error)
          // history.push("/")
          window.location.href = process.env.RAZZLE_APP_BASE_URL;
        })
      } else if (pushToUrl) {
        console.log("<<< pushToUrl")
        history.push(`/${pushToUrl}`);
      } else {
        console.log("<<< toHome")
        // history.push("/")
        window.location.href = process.env.RAZZLE_APP_BASE_URL;
      }
      // if (packSlug && packSlug !== "") {
      //   history.push(`/${packSlug}`);
      // }
      // if (fromUrl) {
      //   if (fromUrl == "/") {
      //     history.push(`/`);
      //   } else {
      //     history.push(`/${fromUrl}`);
      //   }
      // } else {
      //history.push("/customerdashboard");
      // console.log(
      //   "after verification token",
      //   otpVerificationResponse.user.token
      // );
      //  history.push("/")
      // dispatch(ExistingCustomerCheck(otpVerificationResponse.user.token))
      //   .then((res) => {
      //     console.log(res, "comment");
      //     if (res) {
      //       const packageSlug = localStorage.getItem("packageSlug");
      //       let packId = localStorage.getItem("packId");

      // if (packId) {
      //   function waitForToken() {
      //     return new Promise((resolve, reject) => {
      //       console.log("LOCAL", packId);

      //       setTimeout(() => {
      //         const datekey = JSON.parse(localStorage.getItem("user"));
      //         const token = datekey.token;
      //         let body = {
      //           package: packId,
      //         };
      //         return packId
      //           ? resolve(
      //               dispatch(AddtoCart(body, token)),
      //               localStorage.removeItem("packId")
      //             )
      //           : reject("PROMISE IS REJECT");
      //       }, 500);
      //     });
      //   }

      //   waitForToken()
      //     .then((value) => {
      //       console.log("VALUE IS:",packSlug,fromUrl, value);
      //       localStorage.removeItem("packId");
      //       if(to){
      //         history.push("/imaging/cart");
      //       }else{
      //         history.push("/cart");
      //       }
      //     })
      //     .carch((error) => console.log("ERROS IS:", error));
      // }

      // async function asyncCall() {
      //   let packId = await localStorage.getItem("packId");
      //   console.log("LOCAL", packId);
      //   let body = {
      //     package: packId,
      //   };

      //   dispatch(AddtoCart(body, token));
      //   history.push("/cart");
      //   localStorage.removeItem("packId"); // expected output: "resolved"
      // }

      // if (packageSlug && packageSlug !== "") {
      //   if (packageSlug.includes("imaging")) {
      //     history.push(packageSlug);
      //     localStorage.removeItem("packageSlug");
      //   } else {
      //     history.push(
      //       `/${packageSlug}${
      //         selectedCity.citySelect
      //           ? `-${selectedCity.citySelect.toLowerCase()}`
      //           : ""
      //       }`
      //     );
      //     localStorage.removeItem("packageSlug");
      //   }
      // } else {
      //   history.push("/");
      // }
      // console.log(res, "comment");
      //   } else {
      //     setOtpForm(false);
      //     setuserdetail(false);
      //   }
      // })
      // .catch((error) => console.log(error));
    }
    // history.push("/customerdashboard")
    // window.location.replace("/customerdashboard");
  }, [loading]);

  var [otp1, setotp1] = useState(new Array(6).fill(""));

  // var fulldata = otp1.map((data)=>(data))
  // console.log(fulldata.join(""));

  const handleChange1 = (element, index) => {
    console.log("...__---==><==---__...");
    if (isNaN(element.value)) return false;
    setotp1([...otp1.map((d, idx) => (idx === index ? element.value : d))]);

    var input = document.getElementById(`id${index}`);

    input.onkeydown = function (e) {
      console.log(e, "function keyyy");
      console.log(input, "input");
      var key = e.keyCode || e.charCode;
      if (key == 8 || key == 46) {
        const next = e.target.tabIndex;
        console.log(next, "nextttt");
        // input.val('')
        input.previousSibling.focus();
      }
    };

    if (element.nextSibling) {
      element.nextSibling.focus();
    }
  };

  // }
  useEffect(() => {
    Scroll();
  }, []);
  useEffect(() => {
    let myInterval = setInterval(() => {
      if (seconds > 0) {
        setSeconds(seconds - 1);
      }
      if (seconds === 0) {
        if (minutes === 0) {
          clearInterval(myInterval);
        } else {
          setMinutes(minutes - 1);
          setSeconds(59);
        }
      }
    }, 1000);
    return () => {
      clearInterval(myInterval);
    };
  });

  const handleOtpSubmit = (e) => {
    //getting data from store
    e.preventDefault();

    const data123 = otp;
    console.log("otp login response", otpverification);
    //getting code ends here
    // console.log(data123,"password");
    const otpverifyModel = {
      user: {
        email: `${OtpLoginResponse.phone_number}`,
        password: `${data123}`,
      },
    };
    setOtpVerify("");
    setTimeout(() => {
      setOtpError("");
    }, 2000);
    dispatch(otpVerification(otpverifyModel));
    dispatch(setLogout(false));

    // setTimeout(() => {
    //   setuserdetail(true);
    // }, 2000);

    setLoginForm(false);
    setOtpForm(true);

    // console.log("here now ");
  };

  const handleChangeOtp = (otp) => {
    // console.log(otp,"////")
    setOtp(otp);
  };

  return (
    <div>
      <NewHeader />
      <div className="loginHeading">
        <h1>Welcome To Redcliffe Labs! </h1>
      </div>
      <div className="PhoneLoginMain_div">
        <div className="LoginFormDiv LoginFormDiv1024">
          <div className="imageDivOfLogin">
            {/* <img src={loginmodelimage} alt="loginmodelimage" style={{width:'100%'}} /> */}
            <Carousel
              autoPlay={true}
              showIndicators={true}
              showArrows={false}
              showStatus={false}
              showThumbs={false}
              interval={2500}
              infiniteLoop={true}
              transitionTime={1000}
            >
              {LoginImages.map((ImagesData, index) => (
                <div key={index}>
                  <div className="loginSvg">
                    <img src={ImagesData.img} alt="loginphoto" />
                  </div>
                  <div className="TitleAndDesc">
                    <p className="loginImagetitle">{ImagesData.title}</p>
                    <p className="loginImagedesc">{ImagesData.desc}</p>
                  </div>
                </div>
              ))}
            </Carousel>
          </div>
          <form
            className={loginForm ? "modal-form login-form " : "hide"}
            onSubmit={handleSubmit}
          >
            <h2>Login/Sign Up</h2>
            <p className="Loginpara1">
              Please Enter Your Phone Number to Proceed
            </p>
            <p className="Loginpara2"> Phone Number</p>

            <input
              onChange={handleChange}
              value={phoneNumber}
              placeholder="Enter Phone number"
              required
            ></input>
            <span value={messageTel} className="errors">
              {messageTel}
            </span>

            <button
              disabled={disable}
              className={disable ? "Login__submit disable " : "Login__submit"}
            >
              <span className="btn"> PROCEED</span>
            </button>
          </form>

          {/** VERIFYING OTP */}

          <form
            onSubmit={handleOtpSubmit}
            autoComplete="off"
            className={otpForm ? "modal-form login-form show" : " hide"}
          >
            <h2>Verify OTP</h2>
            {/* <h2>OTP2={otp2}</h2> */}
            <p className="Loginpara1">Please enter 6-digit OTP</p>
            <p className="Loginpara2"> OTP</p>
            {resend ? (
              <div className="otpFieldDiv">
                {/* {otp1.map((data, index) => (
                  <input
                    className="otpField"
                    placeholder="-"
                    type="text"
                    name="otp"
                    id={`id${index}`}
                    required
                    maxLength="1"
                    key={index}
                    value={data}
                    tabIndex={`${index}`}
                    onChange={(e) => handleChange1(e.target, index)}
                    onFocus={(e) => e.target.select()}
                  />
                ))} */}
                <OtpInput
                  inputStyle={{
                    width: "5rem",
                    height: "5rem",
                    margin: "20px 1rem",
                    color: "#353535",
                    fontSize: "2rem",
                    borderRadius: "1",
                    border: "1px solid #e3e3e3",
                  }}
                  value={otp}
                  onChange={handleChangeOtp}
                  numInputs={6}
                  separator={false}
                  isInputNum={true}
                />
              </div>
            ) : (
              <div className={error ? "BorDer_red otpFieldDiv" : "otpFieldDiv"}>
                {/* {otp1.map((data, index) => (
                  <input
                    className="otpField"
                    placeholder="-"
                    type="text"
                    name="otp"
                    id={`id${index}`}
                    required
                    maxLength="1"
                    key={index}
                    value={data}
                    tabIndex={`${index}`}
                    onChange={(e) => handleChange1(e.target, index)}
                    onFocus={(e) => e.target.select()}
                  />
                ))} */}

                <OtpInput
                  inputStyle={{
                    width: "5rem",
                    height: "5rem",
                    margin: "20px 1rem",
                    color: "#353535",
                    fontSize: "2rem",
                    borderRadius: "1",
                    border: "1px solid #e3e3e3",
                  }}
                  value={otp}
                  onChange={handleChangeOtp}
                  numInputs={6}
                  separator={false}
                  isInputNum={true}
                />
              </div>
            )}
            {otpError == "" ? null : (
              <span className="otpError">{otpError}</span>
            )}
            {seconds !== 0 && (
              <span className="clearOtp">
                {" "}
                00:{seconds < 10 ? `0${seconds}` : seconds}
              </span>
            )}
            <span onClick={otpClear} className="clearOtp">
              Clear OTP
            </span>
            <button type="submit" className="Login_submit">
              <span className="btn">Verify OTP </span>
            </button>
            {seconds == 0 ? (
              <div className="OtpResendDiv">
                <p className="codeResend">Did not receive the code?</p>

                <p onClick={handleResend} className="resendOtp">
                  Re-Send OTP
                </p>
              </div>
            ) : (
              <span></span>
            )}
          </form>
          {/*User Details */}
          <form
            className={userdetail ? "modal-form login-form " : "hide"}
            onSubmit={handleUserDetailSubmit}
          >
            <h2>Enter Your Details</h2>
            <div className="LoginInputField">
              <p className="InputHeading">Name</p>

              <input
                type="text"
                required
                onChange={handleName}
                value={UserName}
                placeholder="Enter your name"
              ></input>
              <span className="formError">
                {nameError == "" ? null : nameError}
              </span>
            </div>
            <div className="LoginInputField">
              <p className="InputHeading">Email</p>
              <input
                type="email"
                required
                onChange={handleEmail}
                value={Email}
                placeholder="Enter email address"
              ></input>
              <span className="formError">
                {emailError == "" ? null : emailError}
              </span>
            </div>

            <div className="Login_two_InputField">
              <div className="Login_first_InputField">
                <p className="InputHeading">Age</p>
                <input
                  type="number"
                  required
                  onChange={handleAge}
                  value={age}
                  placeholder="Age in Years"
                  className="AgeInput"
                ></input>
                <span className="formError">
                  {ageError == "" ? null : ageError}
                </span>
              </div>
              <div className="Login_second_InputField">
                <p className="GenderInputHeading">Gender</p>
                <div className="genderRadio">
                  <label className="genderLabel">
                    <input
                      type="radio"
                      value="Male"
                      checked={Gender === "Male"}
                      onChange={handleGender}
                    />
                    <span className="GenderSpan">Male</span>
                  </label>
                  <label className="genderLabel">
                    <input
                      type="radio"
                      value="Female"
                      checked={Gender === "Female"}
                      onChange={handleGender}
                    />
                    <span className="GenderSpan">Female</span>
                  </label>
                  <label className="genderLabel">
                    <input
                      type="radio"
                      value="Others"
                      checked={Gender === "Others"}
                      onChange={handleGender}
                    />
                    <span className="GenderSpan">Others</span>
                  </label>
                </div>
              </div>
            </div>
            <button
              disabled={disable}
              className={disable ? "Login__submit disable " : "Login__submit"}
            >
              <span className="btn">UPDATE DETAILS</span>
            </button>
          </form>
        </div>
      </div>
      <ScrolltoTop />
      <Footer />
      <SubFooter />
    </div>
  );
};

export default {
  component: PhoneLogin,
};
